/** CoStar.Api.AptsContent.ArticleSectionTypes */
export var ArticleSectionTypes;
(function (ArticleSectionTypes) {
    ArticleSectionTypes[ArticleSectionTypes["None"] = 0] = "None";
    ArticleSectionTypes[ArticleSectionTypes["Overview"] = 1] = "Overview";
    ArticleSectionTypes[ArticleSectionTypes["Restaurants"] = 2] = "Restaurants";
    ArticleSectionTypes[ArticleSectionTypes["History"] = 3] = "History";
    ArticleSectionTypes[ArticleSectionTypes["Transportation"] = 4] = "Transportation";
    ArticleSectionTypes[ArticleSectionTypes["Cost"] = 5] = "Cost";
    ArticleSectionTypes[ArticleSectionTypes["Shopping"] = 6] = "Shopping";
    ArticleSectionTypes[ArticleSectionTypes["Parks"] = 7] = "Parks";
    ArticleSectionTypes[ArticleSectionTypes["Highlights"] = 8] = "Highlights";
    ArticleSectionTypes[ArticleSectionTypes["Headline"] = 9] = "Headline";
    ArticleSectionTypes[ArticleSectionTypes["Tags"] = 10] = "Tags";
    ArticleSectionTypes[ArticleSectionTypes["Blog"] = 11] = "Blog";
})(ArticleSectionTypes || (ArticleSectionTypes = {}));
/** CoStar.Api.AptsContent.ArticleSourceTypes */
export var ArticleSourceTypes;
(function (ArticleSourceTypes) {
    ArticleSourceTypes[ArticleSourceTypes["None"] = 0] = "None";
    ArticleSourceTypes[ArticleSourceTypes["Apartments"] = 1] = "Apartments";
    ArticleSourceTypes[ArticleSourceTypes["ApartmentFinder"] = 2] = "ApartmentFinder";
})(ArticleSourceTypes || (ArticleSourceTypes = {}));
/** CoStar.Api.AptsContent.ArticleEntityType */
export var ArticleEntityType;
(function (ArticleEntityType) {
    ArticleEntityType[ArticleEntityType["None"] = 0] = "None";
    ArticleEntityType[ArticleEntityType["Home"] = 1] = "Home";
    ArticleEntityType[ArticleEntityType["City"] = 2] = "City";
    ArticleEntityType[ArticleEntityType["Neighborhood"] = 3] = "Neighborhood";
    ArticleEntityType[ArticleEntityType["State"] = 4] = "State";
    ArticleEntityType[ArticleEntityType["County"] = 5] = "County";
    ArticleEntityType[ArticleEntityType["Military"] = 6] = "Military";
    ArticleEntityType[ArticleEntityType["College"] = 7] = "College";
})(ArticleEntityType || (ArticleEntityType = {}));
